/** @format */

export const ID_ROOT = 'card-root';
export const ID_BUTTON = 'card-button';
export const ID_OLD_PRICE = 'card-old-price';
